enum DiscountType {
  FixedPercentage,
  RangePercentage,
  FixedAmount,
}

export default DiscountType
